export { default as ExternalLinkSolidIcon } from './ExternalLinkSolidIcon';
